<template>
  <div class="side-panel">
    <v-layout white>
      <search-bar
        @search="filteredSites = filterTable(sites, $event)"
        :columns="headers"
      ></search-bar>
      <v-spacer></v-spacer>
      <v-flex align-self-center shrink>
        <v-btn
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin].includes(
                $store.state.user.role_type
              ))
          "
          @click="createSiteModalVisible = true"
          class="secondary"
          light
          medium
        >
          <div class="font-weight-regular">
            {{ $t("siteDetails.addSite") }}
          </div>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table :headers="headers" :items="filteredSites" hide-actions>
      <template slot="items" slot-scope="props">
        <tr
          @click="
            editSiteModalVisible = true;
            clickedId = props.item.site_id;
          "
        >
          <td class="text-xs-center">{{ props.item.site_id }}</td>
          <td class="text-xs-center">{{ props.item.site_name }}</td>
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.time_zone }}</td>
          <td class="text-xs-center">{{ props.item.country }}</td>
          <td class="text-xs-center">{{ props.item.voluntary_period }}</td>
          <td class="text-xs-center">{{ getSensitivity(props.item.sensitivity) }}</td>
          <td class="text-xs-center">{{ props.item.is_seasonal_breeding == 0 ? $t("siteGenerics.off") : $t("siteGenerics.on") }}</td>
          <td class="text-xs-center">{{ getIncDecActivityAlerts(props.item.inc_dec_activity_alerts) }}</td>
        </tr>
      </template>
    </v-data-table>
    <div class="danger-alert" v-if="error">{{ error }}</div>
    <v-dialog v-model="createSiteModalVisible" max-width="500px">
      <create-site
        v-on:close="
          createSiteModalVisible = false;
          load();
        "
      ></create-site>
    </v-dialog>
    <v-dialog v-model="editSiteModalVisible" max-width="500px">
      <edit-site
        v-on:close="
          editSiteModalVisible = false;
          load();
        "
        :selectedId="this.clickedId"
      ></edit-site>
    </v-dialog>
  </div>
</template>

<script>
import SitesService from "@/services/SitesService";
import EditSite from "@/components/EditSite";
import CreateSite from "@/components/CreateSite";
import FilterTable from "@/helpers/FilterTable.js";
import { RoleTypes } from "@/constants/role_types";

export default {
  components: {
    EditSite,
    CreateSite
  },
  mixins: [FilterTable],
  data() {
    return {
      headers: [
        {
          text: this.$t("siteGenerics.siteId"),
          sortable: false,
          value: "siteID",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.siteName"),
          value: "siteName",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.siteDescr"),
          value: "description",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.timezone"),
          value: "timezoneName",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.country"),
          value: "country",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.voluntaryPeriod"),
          value: "voluntaryPeriod",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.sensitivity"),
          value: "sensitivity",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.isSeasonalBreeding"),
          value: "isSeasonalBreeding",
          align: "center"
        },
        {
          text: this.$t("siteGenerics.incDecActivityAlerts"),
          value: "incDecActivityAlerts",
          align: "center"
        }
      ],
      sites: [],
      loading: null,
      createSiteModalVisible: false,
      editSiteModalVisible: false,
      error: null,
      clickedId: null, // identify the site to be edited
      filteredSites: [],
      RoleTypes: RoleTypes
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      try {
        this.error = null;
        this.loading = true;
        this.filteredSites = this.sites = (await SitesService.index()).data;
        this.loading = false;
      } catch (err) {
        this.error = err.response.data.error.message;
      }
    },
    getSensitivity(sensitivity) {
      switch (sensitivity) {
        case 'OFF':
          return this.$t("siteGenerics.off");
        case 'LOW':
          return this.$t("siteGenerics.low");
        case 'MEDIUM':
          return this.$t("siteGenerics.medium");
        case 'HIGH':
          return this.$t("siteGenerics.high");
        default:
          return this.$t("siteGenerics.notValid");
      }
    },
    getIncDecActivityAlerts(incDecActivityAlerts) {
      switch (incDecActivityAlerts) {
        case 'INCR':
          return this.$t("siteGenerics.incrDecrOptions.incrOnly");
        case 'DECR':
          return this.$t("siteGenerics.incrDecrOptions.decrOnly");
        case 'BOTH':
          return this.$t("siteGenerics.incrDecrOptions.both");
        default:
          return this.$t("siteGenerics.off");
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Sites.vue